;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .factory('AgileCentralBugtrackerService', AgileCentralBugtrackerService)

  function AgileCentralBugtrackerService(
    $q,
    $location,
    UserService,
    rulesBugtrackerService,
    ServiceUtils,
    BugtrackerFactory,
    AGILE_CENTRAL_FIELD_TYPES,
    FILTER_GROUPS,
    AGILE_CENTRAL_FIELD_KEYS,
    AGILE_CENTRAL_OBJECT_PROPERTIES,
    BUGTRACKER_UNUSED_FIELD_VALUE,
    BUGTRACKER_DEFAULT_TEST_NAME
  ) {
    'ngInject'

    return {
      getBugtrackerForVulnerability: getBugtrackerForVulnerability,
      getBugtrackerForLibrary:
        BugtrackerFactory.getAgileCentralBugtrackerForLibrary,
      getPriorityByTraces: getPriorityByTraces,
      buildAgileCentralBugtrackerSettings: buildAgileCentralBugtrackerSettings,

      getBugtracker: getBugtracker,
      addAgileCentralBugtracker: addAgileCentralBugtracker,
      testAgileCentralBugtracker: testAgileCentralBugtracker,
      testExistingAgileCentralBugtracker: testExistingAgileCentralBugtracker,
      editAgileCentralBugtracker: editAgileCentralBugtracker,

      getProjects: getProjects,
      getEditors: getEditors,
      getUser: getUser,
      getDefectTypeDefinition: getDefectTypeDefinition,
      getDefectAttributes: getDefectAttributes,
      getAllowedValues: getAllowedValues,

      buildAgileCentralBugtracker: buildAgileCentralBugtracker,
      setupAgileCentralBugtrackerBaseProperties:
        setupAgileCentralBugtrackerBaseProperties,
      buildAgileCentralBugtrackerBaseProperties:
        buildAgileCentralBugtrackerBaseProperties,
      buildAgileCentralBugtrackerProperties:
        buildAgileCentralBugtrackerProperties,
      addAgileCentralIntegration: addAgileCentralIntegration,
      buildAgileCentralIntegration: buildAgileCentralIntegration,
      buildAgileCentralIntegrationTest: buildAgileCentralIntegrationTest,
      getUrl: getUrl,
      getObjectIdFromReference: getObjectIdFromReference,
      removeEmptyValueFromArray: removeEmptyValueFromArray,
      transformToIntegrationView: transformToIntegrationView
    }

    function getProjects(request, id) {
      if (id) {
        return BugtrackerFactory.getAgileCentralProjectsByBugtracker(
          id,
          request
        )
      }
      return BugtrackerFactory.getAgileCentralProjects(request)
    }

    function getEditors(request, projectId, keyword, id) {
      if (id) {
        return BugtrackerFactory.getAgileCentralEditorsByBugtracker(
          id,
          request,
          projectId,
          keyword
        )
      }
      return BugtrackerFactory.getAgileCentralEditors(
        request,
        projectId,
        keyword
      )
    }

    function getUser(request, reference, id) {
      if (id) {
        return BugtrackerFactory.getAgileCentralUserByBugtracker(
          id,
          request,
          reference
        )
      }
      return BugtrackerFactory.getAgileCentralUser(request, reference)
    }

    function getDefectTypeDefinition(request, id) {
      if (id) {
        return BugtrackerFactory.getAgileCentralDefectTypeDefinitionByBugtracker(
          id,
          request
        )
      }
      return BugtrackerFactory.getAgileCentralDefectTypeDefinition(request)
    }

    function getDefectAttributes(request, defectId, id) {
      if (id) {
        return BugtrackerFactory.getAgileCentralDefectAttributesByBugtracker(
          id,
          request,
          defectId
        )
      }
      return BugtrackerFactory.getAgileCentralDefectAttributes(
        request,
        defectId
      )
    }

    function getAllowedValues(request, attributeId, id) {
      if (id) {
        return BugtrackerFactory.getAgileCentralAllowedValuesByBugtracker(
          id,
          request,
          attributeId
        )
      }
      return BugtrackerFactory.getAgileCentralAllowedValues(
        request,
        attributeId
      )
    }

    function buildAgileCentralBugtrackerSettings(vm, data) {
      vm.select.projects = data.settings.projects
      vm.select.priorities = data.settings.priorities
      vm.select.assignees = data.settings.assignees
      vm.selected_fields = angular.copy(data.bugtracker.fields)
      vm.properties = _buildAgileCentralBugtrackerProperties(
        data.bugtracker,
        vm.select
      )
    }

    function _buildAgileCentralBugtrackerProperties(settings, select) {
      var properties = {}
      properties.project = _.find(select.projects, {
        id: settings.project
      })
      properties.assignee = _.find(select.assignees, {
        key: settings.assignee
      })
      properties.priority_critical = _.find(select.priorities, {
        name: settings.priority_critical
      })
      properties.priority_high = _.find(select.priorities, {
        name: settings.priority_high
      })
      properties.priority_medium = _.find(select.priorities, {
        name: settings.priority_medium
      })
      properties.priority_low = _.find(select.priorities, {
        name: settings.priority_low
      })
      properties.priority_note = _.find(select.priorities, {
        name: settings.priority_note
      })

      return properties
    }

    function getBugtrackerForVulnerability(bugtrackerId, appId) {
      return BugtrackerFactory.getAgileCentralBugtrackerForVulnerability(
        bugtrackerId,
        appId
      )
    }

    function getPriorityByTraces(id, traces, appId) {
      return BugtrackerFactory.getAgileCentralPriorityByTraces(
        id,
        traces,
        appId
      )
    }

    function getBugtracker(id) {
      return BugtrackerFactory.getAgileCentralBugtracker(id)
        .then(function (response) {
          return {
            selected_appids: response.data.bugtracker.applications,
            selected_fields: angular.copy(response.data.bugtracker.fields),
            bugtracker: response.data.bugtracker,
            integrations: response.data.integrations
          }
        })
        .catch(ServiceUtils.handleError)
    }

    function addAgileCentralBugtracker(bugtracker) {
      return BugtrackerFactory.addAgileCentralBugtracker(bugtracker)
        .then(function (response) {
          ServiceUtils.logSuccess(response)
          $location.path(UserService.buildUrl('/settings/integration'), true)
        })
        .catch(ServiceUtils.handleError)
    }

    function testAgileCentralBugtracker(bugtracker) {
      return BugtrackerFactory.testAgileCentralBugtracker(bugtracker)
        .then(function (response) {
          return response.data.settings
        })
        .catch(function (response) {
          return $q.reject(response.data)
        })
    }

    function editAgileCentralBugtracker(id, bugtracker) {
      return BugtrackerFactory.editAgileCentralBugtracker(id, bugtracker)
        .then(function (response) {
          ServiceUtils.logSuccess(response)
          $location.path(UserService.buildUrl('/settings/integration'), true)
        })
        .catch(ServiceUtils.handleError)
    }

    function testExistingAgileCentralBugtracker(id, bugtracker) {
      return BugtrackerFactory.testExistingAgileCentralBugtracker(
        id,
        bugtracker
      )
        .then(function (response) {
          return response.data.settings
        })
        .catch(function (response) {
          return $q.reject(response.data)
        })
    }

    function buildAgileCentralBugtracker(bugtracker) {
      var bugtrackerView = {}
      bugtrackerView.name = bugtracker.name

      bugtrackerView.host = bugtracker.credentials.host
      bugtrackerView.credentialsId = bugtracker.credentials.id
      bugtrackerView.credentials = bugtracker.credentials

      bugtrackerView.all_applications = bugtracker.all_applications
      bugtrackerView.applications = []
      bugtrackerView.integrations = []

      bugtrackerView.auto_create_tickets_enabled =
        bugtracker.auto_create_tickets_enabled
      bugtrackerView.auto_create_tickets_rules =
        bugtracker.auto_create_tickets_rules
      bugtrackerView.auto_create_tickets_severities =
        bugtracker.auto_create_tickets_severities
      bugtrackerView.auto_create_tickets_all_rules =
        bugtracker.auto_create_tickets_all_rules

      return bugtrackerView
    }

    function setupAgileCentralBugtrackerBaseProperties(bugtracker, select) {
      var properties = {
        project: _.find(select.projects, { ref: bugtracker.project })
      }
      properties.owner = _buildAgileCentralProperty(
        bugtracker.fields,
        AGILE_CENTRAL_FIELD_KEYS.OWNER
      )
      properties.submittedBy = _buildAgileCentralProperty(
        bugtracker.fields,
        AGILE_CENTRAL_FIELD_KEYS.SUBMITTED_BY
      )
      properties.environment = _buildAgileCentralProperty(
        bugtracker.fields,
        AGILE_CENTRAL_FIELD_KEYS.ENVIRONMENT
      )
      properties.state = _buildAgileCentralProperty(
        bugtracker.fields,
        AGILE_CENTRAL_FIELD_KEYS.STATE
      )

      properties.priority_critical = {
        stringValue: bugtracker.priority_critical
      }
      properties.priority_high = { stringValue: bugtracker.priority_high }
      properties.priority_medium = { stringValue: bugtracker.priority_medium }
      properties.priority_low = { stringValue: bugtracker.priority_low }
      properties.priority_note = { stringValue: bugtracker.priority_note }

      return properties
    }

    function _buildAgileCentralProperty(fields, fieldKey) {
      var field = _.find(fields, { key: fieldKey })
      if (!field) {
        return undefined
      }

      switch (field.type) {
        case AGILE_CENTRAL_FIELD_TYPES.REFERENCE:
          return { ref: field.value }
        case AGILE_CENTRAL_FIELD_TYPES.STRING:
        case AGILE_CENTRAL_FIELD_TYPES.BOOLEAN:
          return { stringValue: field.value }
        case AGILE_CENTRAL_FIELD_TYPES.ARRAY:
        case AGILE_CENTRAL_FIELD_TYPES.REFERENCE_ARRAY:
          return _buildAgileCentralFieldArray(field)

        default:
          return undefined
      }
    }

    function _buildAgileCentralFieldArray(field) {
      var property = []
      var values = field.value.split(',')
      _.each(values, function (value) {
        if (field.type === AGILE_CENTRAL_FIELD_TYPES.REFERENCE_ARRAY) {
          property.push({ ref: value })
        } else {
          property.push({ stringValue: value })
        }
      })
      return property
    }

    function buildAgileCentralBugtrackerBaseProperties(properties, select) {
      properties.priority_critical = _getPropertyFromSelect(
        select.priorities,
        properties.priority_critical,
        AGILE_CENTRAL_OBJECT_PROPERTIES.STRING_VALUE
      )
      properties.priority_high = _getPropertyFromSelect(
        select.priorities,
        properties.priority_high,
        AGILE_CENTRAL_OBJECT_PROPERTIES.STRING_VALUE
      )
      properties.priority_medium = _getPropertyFromSelect(
        select.priorities,
        properties.priority_medium,
        AGILE_CENTRAL_OBJECT_PROPERTIES.STRING_VALUE
      )
      properties.priority_low = _getPropertyFromSelect(
        select.priorities,
        properties.priority_low,
        AGILE_CENTRAL_OBJECT_PROPERTIES.STRING_VALUE
      )
      properties.priority_note = _getPropertyFromSelect(
        select.priorities,
        properties.priority_note,
        AGILE_CENTRAL_OBJECT_PROPERTIES.STRING_VALUE
      )
      properties.environment = _getPropertyFromSelect(
        select.environments,
        properties.environment,
        AGILE_CENTRAL_OBJECT_PROPERTIES.STRING_VALUE
      )
      properties.state = _getPropertyFromSelect(
        select.states,
        properties.state,
        AGILE_CENTRAL_OBJECT_PROPERTIES.STRING_VALUE
      )
      return properties
    }

    function _getPropertyFromSelect(select, property, valueName) {
      if (!property) {
        return undefined
      }
      var searchCriteria = []
      searchCriteria[valueName] = property[valueName]

      return _.find(select, searchCriteria)
    }

    function buildAgileCentralBugtrackerProperties(bugtracker, select) {
      var properties = {}
      properties.assignee = _.find(select.assignees, {
        key: bugtracker.assignee
      })
      return properties
    }

    function addAgileCentralIntegration(data, properties) {
      if (properties.priority) {
        data.priority = properties.priority.stringValue
      }
      data.agile_central_fields = []
      if (properties.environment) {
        data.agile_central_fields.push(
          _buildAgileCentralField(
            AGILE_CENTRAL_FIELD_KEYS.ENVIRONMENT,
            AGILE_CENTRAL_FIELD_TYPES.STRING,
            properties.environment.stringValue
          )
        )
      }
      if (properties.state) {
        data.agile_central_fields.push(
          _buildAgileCentralField(
            AGILE_CENTRAL_FIELD_KEYS.STATE,
            AGILE_CENTRAL_FIELD_TYPES.STRING,
            properties.state.stringValue
          )
        )
      }
      if (properties.owner) {
        data.agile_central_fields.push(
          _buildAgileCentralField(
            AGILE_CENTRAL_FIELD_KEYS.OWNER,
            AGILE_CENTRAL_FIELD_TYPES.REFERENCE,
            properties.owner.ref
          )
        )
      }
      if (properties.submittedBy) {
        data.agile_central_fields.push(
          _buildAgileCentralField(
            AGILE_CENTRAL_FIELD_KEYS.SUBMITTED_BY,
            AGILE_CENTRAL_FIELD_TYPES.REFERENCE,
            properties.submittedBy.ref
          )
        )
      }
    }

    function buildAgileCentralIntegration(model, properties) {
      var request = {}
      request.name = model.name
      if (model.host) {
        request.credentials = {}
        request.credentials.name = model.credentials
          ? model.credentials.name
          : model.name + ' credentials'
        request.credentials.username = model.username
        request.credentials.password = model.password
        request.credentials.host = model.host
      }
      request.credentials_id = model.credentialsId
        ? model.credentialsId
        : undefined

      if (model.all_applications) {
        request.applications = []
      } else {
        request.applications = _.map(model.applications, 'app_id')
      }

      request.all_applications = model.all_applications

      //build auto create tickets request part
      request.auto_create_tickets_enabled = model.auto_create_tickets_enabled
      request.auto_create_tickets_rules = []
      request.auto_create_tickets_severities = []

      if (!model.auto_create_tickets_enabled) {
        request.auto_create_tickets_all_rules = false
      } else {
        if (model.auto_create_tickets_all_rules) {
          request.auto_create_tickets_all_rules = true
        } else {
          _buildRulesRequestSection(request, model)
          request.auto_create_tickets_all_rules = false
        }
      }

      request.project = properties.project.ref
      request.assignee = BUGTRACKER_UNUSED_FIELD_VALUE
      request.issue_type = BUGTRACKER_UNUSED_FIELD_VALUE
      request.priority_field_available = true

      if (properties.priority_critical) {
        request.priority_critical = properties.priority_critical.stringValue
      }
      if (properties.priority_high) {
        request.priority_high = properties.priority_high.stringValue
      }
      if (properties.priority_medium) {
        request.priority_medium = properties.priority_medium.stringValue
      }
      if (properties.priority_low) {
        request.priority_low = properties.priority_low.stringValue
      }
      if (properties.priority_note) {
        request.priority_note = properties.priority_note.stringValue
      }

      request.fields = _buildBasicFields(properties)

      return request
    }

    function _buildBasicFields(properties) {
      var fields = []
      if (properties.owner) {
        fields.push(
          _buildAgileCentralField(
            AGILE_CENTRAL_FIELD_KEYS.OWNER,
            AGILE_CENTRAL_FIELD_TYPES.REFERENCE,
            properties.owner.ref
          )
        )
      }
      if (properties.environment) {
        fields.push(
          _buildAgileCentralField(
            AGILE_CENTRAL_FIELD_KEYS.ENVIRONMENT,
            AGILE_CENTRAL_FIELD_TYPES.STRING,
            properties.environment.stringValue
          )
        )
      }
      if (properties.state) {
        fields.push(
          _buildAgileCentralField(
            AGILE_CENTRAL_FIELD_KEYS.STATE,
            AGILE_CENTRAL_FIELD_TYPES.STRING,
            properties.state.stringValue
          )
        )
      }
      if (properties.submittedBy) {
        fields.push(
          _buildAgileCentralField(
            AGILE_CENTRAL_FIELD_KEYS.SUBMITTED_BY,
            AGILE_CENTRAL_FIELD_TYPES.REFERENCE,
            properties.submittedBy.ref
          )
        )
      }

      return fields
    }

    function _buildAgileCentralField(key, type, value) {
      return {
        key: key,
        type: type,
        value: value
      }
    }

    function buildAgileCentralIntegrationTest(model, hasPreviousCredentials) {
      var request = {}

      if (!model.name && hasPreviousCredentials) {
        request.name = BUGTRACKER_DEFAULT_TEST_NAME
      } else {
        request.name = model.name
      }

      if (model.host) {
        request.credentials = {}
        request.credentials.password = model.password
        request.credentials.host = model.host
        request.credentials.name = model.credentials
          ? model.credentials.name
          : model.name + ' credentials'
      }
      request.credentials_id = model.credentialsId
        ? model.credentialsId
        : undefined

      return request
    }

    function getUrl(AgileCentralId, isEdit) {
      var getUrlRequest
      if (isEdit) {
        getUrlRequest =
          BugtrackerFactory.createAgileCentralUrlWebhookFromExistingBugtracker(
            AgileCentralId
          )
      } else {
        getUrlRequest = BugtrackerFactory.createAgileCentralUrlWebhook()
      }

      return getUrlRequest
        .then(function (response) {
          return response.data.url
        })
        .catch(ServiceUtils.handleError)
    }

    /**
     * Extracts the ObjectID from a Agile Central reference (a full URI or the classic /project/ObjectID format).
     * @param {string} reference A full URI ($host/slm/webservice/$version/user/$ObjectID) or short format string (/user/$ObjectID) that represents an Agile Central Object reference.
     */
    function getObjectIdFromReference(reference) {
      var barPos = reference.lastIndexOf('/') + 1
      var length = reference.length - barPos
      return reference.substr(barPos, length)
    }

    function removeEmptyValueFromArray(list) {
      var emptyIndex = _.findIndex(list, function (item) {
        return !item.stringValue
      })
      if (emptyIndex < 0) {
        return list
      }
      list.splice(emptyIndex, 1)
      return list
    }

    function transformToIntegrationView(integration, rules) {
      var form = {
        name: integration.name,

        credentials: integration.credentials,
        isCredentialsUpdate: integration.isCredentialsUpdate,
        credentialsId: integration.credentialsId,

        host: integration.host,
        username: integration.username,
        password: integration.password,

        applications: integration.applications,
        all_applications: integration.all_applications,
        integration: integration.integration,
        generating_url: integration.generating_url,
        url: integration.url,
        integrations: integration.integrations,

        auto_create_tickets_enabled: integration.auto_create_tickets_enabled,
        auto_create_tickets_all_rules:
          integration.auto_create_tickets_all_rules,
        auto_create_tickets_rules: [],
        auto_create_tickets_severities: []
      }

      if (!form.auto_create_tickets_all_rules) {
        rulesBugtrackerService.transformRulesToIntegrationView(
          integration,
          rules,
          form
        )
      }

      return form
    }

    function _buildRulesRequestSection(data, integration) {
      _.each(integration.auto_create_tickets_rules, function (ruleItem) {
        if (ruleItem.group === FILTER_GROUPS.SEVERITY) {
          data.auto_create_tickets_severities.push(ruleItem.value)
        } else {
          data.auto_create_tickets_rules.push(ruleItem.value)
        }
      })
    }
  }
})()
